var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClearbit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1100px",
    height: "1100px",
    viewBox: "0 0 1100 1100",
    enableBackground: "new 0 0 1100 1100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 611.113,
    y: 476.828,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#447EC0",
    width: 19.08,
    height: 126.043
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1007.444,
    y: 522.299,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#447EC0",
    width: 19.083,
    height: 80.572
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#447EC0",
    d: "M860.44,534.758v-12.459h-19.083v80.572h19.083v-33.708v-0.597v-6.82c0-10.381,8.6-27.977,27.879-22.538 c0-11.665,0-18.291,0-18.291S872.201,516.667,860.44,534.758z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#447EC0",
    d: "M669.738,555.221c0.987-7.416,5.439-19.67,23.526-19.67c18.392,0,18.784,19.67,18.784,19.67H669.738z  M693.563,520.421c-42.015,0-42.903,38.756-42.903,43.203c0,17.103,9.684,41.325,41.318,41.325 c27.683,0,35.295-15.621,35.295-15.621l-12.947-10.874c0,0-5.046,10.28-21.16,10.28c-16.113,0-22.637-12.65-23.525-19.571 c14.529,0,61.688,0,61.688,0S735.579,520.421,693.563,520.421z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#447EC0",
    d: "M798.454,574.501c0,3.953-4.845,15.618-20.565,15.618c-15.717,0-18.682-12.949-9.292-19.574 c9.395-6.624,29.165-4.352,29.165-4.352h0.594C798.454,566.193,798.454,570.545,798.454,574.501z M785.604,520.421 c-26.298,0-36.679,12.754-36.679,12.754s5.732,7.019,9.395,11.665c8.3-6.13,15.814-8.894,23.133-8.894 c6.817,0,16.702,2.073,17.988,17.495c-11.368-0.988-30.844-0.198-45.77,8.305c-16.409,9.294-8.801,32.031,0.594,37.664 c21.449,12.559,38.059,0.891,45.377-6.125c0,5.83,0,9.787,0,9.787h17.694c0,0,0-44.59,0-51.903 C817.336,543.854,811.897,520.421,785.604,520.421z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#447EC0",
    d: "M943.386,588.043c-15.923,0-20.865-13.842-22.347-21.452V556.21c3.366-10.58,9.987-19.574,23.726-19.574 c17.105,0,22.839,16.313,22.839,24.32C967.604,568.961,965.429,588.043,943.386,588.043z M949.811,520.521 c-14.239,0-23.334,7.216-28.771,13.741v-57.435H901.96v126.043h19.079v-11.664c4.053,5.832,12.462,14.037,28.473,14.037 c24.816,0,37.961-23.528,37.961-41.915C987.473,544.941,975.908,520.521,949.811,520.521z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#447EC0",
    cx: 1017.53,
    cy: 495.809,
    rx: 12.653,
    ry: 12.16
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#447EC0",
    d: "M1092.961,522.299h-19.378c0-12.752-0.099-22.539-0.099-22.539h-19.083c0,0,0,9.689,0,22.539h-14.631 v15.324h14.631c0,15.424,0,31.737,0,40.338c0,19.572,10.381,30.448,38.56,23.727c-0.79-7.221-0.691-14.631-0.691-14.631 s-18.588,5.732-18.588-8.899c0-6.722,0-23.923-0.099-40.535h19.378V522.299z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#447EC0",
    d: "M554.961,586.76c-15.818,0-41.323-7.613-41.323-43.204c0-35.59,28.866-43.301,39.745-43.301 c10.872,0,20.262,3.164,27.678,12.06c7.711-6.622,16.016-12.06,16.016-12.06s-12.06-18.094-45.773-18.094 c-33.711,0-60.601,27.089-60.601,61.196s24.221,62.283,61.095,62.283c33.912,0,46.463-20.268,46.463-20.268l-15.619-12.158 C582.445,573.215,570.778,586.76,554.961,586.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5D9CD5",
    d: "M165.944,392.101h115.271c23.233,0,42.116,18.883,42.116,42.116v115.271H165.944V392.101z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B8ECC",
    d: "M8.559,549.488h157.385v157.387H58.781c-27.681,0-50.222-22.44-50.222-50.225V549.488z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7F2FC",
    d: "M165.944,549.488h157.387V666.44c0,22.343-18.093,40.435-40.436,40.435H165.944V549.488z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B8ECC",
    d: "M60.065,392.101h105.879v157.387H8.559V443.606C8.559,415.237,31.594,392.101,60.065,392.101z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearbit);
export default __webpack_public_path__ + "static/media/clearbit.034b03531a7b5c28d753b2408f74692a.svg";
export { ForwardRef as ReactComponent };